import { useMemo } from "react";

import calculateLimitedEditions from '@/services/limited_editions.service';

const useCheckLimitedEditions = (dataNeeded) => {
  const parseUnit = (value, unit) => {
    return unit === "inches" ? value * 2.54 : value;
  };

  const isLimitedEdition = useMemo(() => {
    if (!dataNeeded) return false;
    return calculateLimitedEditions(
      parseUnit(dataNeeded.height, dataNeeded.unit),
      parseUnit(dataNeeded.length, dataNeeded.unit),
      dataNeeded.price
    );
  }, [dataNeeded]);

  return isLimitedEdition;
};

export default useCheckLimitedEditions;